import { render } from "./App.vue?vue&type=template&id=4e199a6b&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4e199a6b&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=4e199a6b&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e199a6b"]])

export default __exports__